export var RiskTreatmentType;
(function (RiskTreatmentType) {
    RiskTreatmentType["Terminate"] = "terminate";
    RiskTreatmentType["Tolerate"] = "tolerate";
    RiskTreatmentType["Transfer"] = "transfer";
    RiskTreatmentType["Treat"] = "treat";
})(RiskTreatmentType || (RiskTreatmentType = {}));
//# sourceMappingURL=risk-treatment-type.js.map